const messages = {
  namespace: field => `The ${field} must contain 3-32 characters, can be lowercase, dash and numbers`,
  custom_price_between: (field, [min, max], value) => {
    if (Number(value) < Number(min)) {
      return `Please refill at least ${Number(min).toLocaleString()} THB.`;
    } else if (Number(value) > Number(max)) {
      return `Please contact ByteArk if you want to refill more than ${Number(max).toLocaleString()} THB`;
    }
    return `The ${field} field must be between ${Number(min).toLocaleString()} and ${Number(max).toLocaleString()}.`;
  },
};

const locale = {
  name: 'en',
  messages,
  attributes: {
    email: 'Email',
    password: 'Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    team: 'Team Display name',
    displayname: 'Display Name',
    role: 'Role',
    first_name: 'First Name',
    last_name: 'Last Name',
    address1: 'Address Line 1',
    city: 'City / Town',
    state: 'State / Province / Region',
    zipcode: 'ZIP Code',
    country: 'Country',
    contact_phone: 'Billing Contact Phone',
    contact_email: 'Billing E-mail',
  },
};

export default locale;



// WEBPACK FOOTER //
// ./src/lang/validator/en.js